import { gql } from '@apollo/client'


export const GET_REPORTS_COUNTERS_WATER_TRUCK_REQUEST = gql`
query GetReportsCountersWaterTruckRequest($filters: reportsCountersWaterTruckRequestFilterInput) {
  getReportsCountersWaterTruckRequest(filters: $filters) {
    generated
    resolved
    effectiveness
    generalPercentage
    counterByDateFilter {
      label
      generated
      resolved
      effectiveness
    }
  }
}
`

export const GET_COUNTERS_WATER_TRUCK_REQUEST_FILTERS_OPTIONS = gql`
    mutation GetCountersWaterTruckRequestFiltersOptions($filters: countersWaterTruckRequestInput) {
        getCountersWaterTruckRequestFiltersOptions(filters: $filters) {
            years
            months {
                label
                value
            }
            weeks {
                label
                value
            }
        }
    }
`